document.addEventListener('keyup', function (e) {
    const key = e.key;

    if (key === 'Tab' || key === 'ArrowUp' || key === 'ArrowDown') {
        var elem = document.body;
        elem.classList.add('keyboard-navigation');
    }
});
document.addEventListener('mousedown', function () {
    var elem = document.body;
    elem.classList.remove('keyboard-navigation');
});
